export const BOOKING_ORIGIN = {
  ONLINE: 0,
  LOCAL: 1,
  MARKETPLACE: 2,
} as const;

export type BookingOrigin = typeof BOOKING_ORIGIN[keyof typeof BOOKING_ORIGIN];
